import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "calendar",
      path: "calendar/:view?/:action?/:type?/:item?",
      props: true,
      meta: {
        icon: "calendar",
        title: i18n.global.t("Calendar"),
      },
      component: () => import("pages/employee/Calendar"),
    },
    {
      name: "old-schedule",
      path: "calendar/old-schedule",
      meta: { icon: "old_schedule", title: i18n.global.t("Old Schedule") },
      component: () => import("pages/employee/OldSchedule"),
    },
  ],

  dialogs: [
    {
      name: "event-type-new",
      path: "/events/new/type/:type/:item",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/EventEdit"),
    },
    {
      name: "event-new",
      path: "/events/new/:start/:end/:resources",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/EventEdit"),
    },
    {
      name: "event-edit",
      path: "/events/:eventID/edit",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/EventEdit"),
    },
    {
      name: "event-view",
      path: "/events/:eventID/view/:date",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/EventView"),
    },
    {
      name: "event-reschedule",
      path: "/events/:eventID/reschedule",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/EventReschedule"),
    },
  ],
};
